import { render, staticRenderFns } from "./EditarVarios.vue?vue&type=template&id=df6132a8"
import script from "./EditarVarios.vue?vue&type=script&lang=js"
export * from "./EditarVarios.vue?vue&type=script&lang=js"
import style0 from "../../components/EditorEspacio/editorEspacio.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../components/EditorEspacio/editorAncho.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./EditarVarios.vue?vue&type=style&index=2&id=df6132a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports